import html2canvas from "html2canvas";
import jsPDF from "jspdf";

/**
 * Downloads one or more HTML elements (referenced by their DOM nodes) as a single PDF file.
 * Each element will start on a new page.
 * @param {HTMLElement | HTMLElement[]} elements - The DOM node(s) to capture.
 * @param {string} filename - The name of the file to download.
 */
export const downloadElementsAsPdf = async (
  elements,
  filename = "document.pdf"
) => {
  // 1. Ensure 'elements' is an array for consistent looping
  const elementArray = Array.isArray(elements) ? elements : [elements];

  if (
    !elementArray ||
    elementArray.length === 0 ||
    !elementArray.every((e) => e instanceof HTMLElement)
  ) {
    console.error(
      "Invalid elements provided. Please ensure you pass a valid HTMLElement or array of HTMLElements."
    );
    return;
  }

  const pdf = new jsPDF("p", "mm", "a4");
  const imgWidth = 210; // A4 width in mm (for consistent size)
  let firstPage = true;

  try {
    for (const element of elementArray) {
      if (!element) continue;

      // Add a new page for every element except the first one
      if (!firstPage) {
        pdf.addPage();
      }

      // Options for html2canvas
      const canvasOptions = {
        scale: 2,
        useCORS: true,
      };

      // 2. Convert the element to a canvas (image)
      const canvas = await html2canvas(element, canvasOptions);

      const imgData = canvas.toDataURL("image/png");
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      // 3. Add the image to the PDF
      // (data, format, x-pos, y-pos, width, height)
      pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);

      firstPage = false;
    }

    // 4. Download the PDF
    pdf.save(filename);
  } catch (error) {
    console.error("Error generating PDF:", error);
    alert("Failed to generate PDF. Check the console for details.");
  }
};
